import { BriefcaseIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline'
import { navigate } from 'gatsby'
import React from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useUIStore } from '../../../stores/ui/uiStore'

export const HeadingListResult = ({
  type,
  query,
}: {
  type: 'offers' | 'firms'
  query?: string
}) => {
  const Icon = type === 'offers' ? BriefcaseIcon : BuildingOfficeIcon
  const closeCommandPalettes = useUIStore(useShallow(state => state.closeCommandPalettes))


  const handleClick = () => {
    if (!query) {
      return
    }

    if (type === 'offers') {
      navigate(`/offres?q=${query}`, { replace: true })
    } else {
      navigate(`/cabinets?q=${query}`, { replace: true })
    }

    closeCommandPalettes()
  }

  return (
    <div className="flex justify-between items-center px-3 py-2 bg-blue-gray-200/20">
      <div className="flex items-center">
        <Icon className="size-6 flex-none text-gray-500 group-data-focus:text-white forced-colors:group-data-focus:text-[Highlight]" aria-hidden="true" />
        <span className="text-xs font-semibold text-gray-500"> - {type === 'offers' ? 'Offres' : 'Cabinets'}</span>
      </div>

      <button type='button' className="text-xs font-semibold" onClick={handleClick}>
        <span className="text-gray-500 hover:underline">Voir plus</span>
      </button>
    </div>
  )
}
